import React, { Component } from "react";
import { Input, Button, Table, Space, Row, Col, Form, Modal } from "antd";
import { DeleteOutlined, SearchOutlined } from "@ant-design/icons";
import { organizationApiService } from "../../services/robofin/OrganizationApiService";

export interface DepositState {
  searchInput: string;
  depositData: { id: string; amount: number }[];
  submitting: boolean;
  totalDeposit: number;
}

export interface DepositProps {
  totalDeposit: number;
  depositData: { id: string; amount: number }[];
  onDepositUpdate: (value: number) => void;
}

class DepositComponent extends Component<DepositProps & any, DepositState> {
  private readonly initState: DepositState;
  private tableColumn: any = [
    {
      title: "ID Deposit",
      dataIndex: "id",
    },
    {
      title: "Nilai Deposit",
      dataIndex: "amount",
      render: (value: string) => {
        return value.toLocaleString();
      },
    },
    {
      title: "Action",
      dataIndex: "id",
      render: (value: string) => {
        return (
          <Space size="middle">
            <Button icon={<DeleteOutlined />} onClick={() => this.handleDelete(value)} />
          </Space>
        );
      },
    },
  ];

  constructor(props: (DepositProps & any) | any) {
    super(props);

    this.initState = {
      searchInput: "",
      totalDeposit: 0,
      depositData: [],
      submitting: false,
    };
    this.state = { ...this.initState };
  }

  componentDidUpdate(prevProps: DepositProps, prevState: DepositState) {
    // Check if totalDeposit or depositData has changed
    if (this.props.totalDeposit !== prevProps.totalDeposit || JSON.stringify(this.props.depositData) !== JSON.stringify(prevProps.depositData)) {
      // Update the state with new totalDeposit and depositData
      this.setState({
        searchInput: "",
        submitting: false,
        totalDeposit: this.props.totalDeposit,
        depositData: this.props.depositData,
      });
    }
  }

  handleSearch = async () => {
    try {
      const { searchInput, depositData } = this.state;

      if (!searchInput) {
        Modal.error({
          title: "Error Validation",
          content: "Deposit ID required",
        });
        return;
      }

      if (depositData.find((item) => item.id === searchInput)) {
        Modal.error({
          title: "Error",
          content: "Data deposit sudah ada",
        });
        return;
      }

      this.setState({ submitting: true });
      const getDeposit = await organizationApiService.getDeposit({
        no_deposits: [searchInput],
      });

      const dataDeposit = getDeposit?.data?.data;
      if (!dataDeposit || dataDeposit.length < 1) {
        throw new Error("Data Not Found");
      }

      if (dataDeposit[0].IsClaimed === true) {
        throw new Error("Deposit sudah di Claim");
      } else {
        const updatedDepositData = [
          ...depositData,
          {
            id: dataDeposit[0].SK,
            amount: Number(dataDeposit[0].TransactionAmount),
            claimed: dataDeposit[0].IsClaimed,
          },
        ];

        const updatedTotalDeposit = this.state.totalDeposit + Number(dataDeposit[0].TransactionAmount);

        this.props.onDepositUpdate(updatedTotalDeposit, updatedDepositData);

        this.setState({
          totalDeposit: updatedTotalDeposit,
          depositData: updatedDepositData,
          submitting: false,
        });
      }
    } catch (error: any) {
      this.setState({ submitting: false });
      Modal.error({
        title: "Error Server",
        content: error.message || "An error occurred while fetching data.",
      });
    }
  };

  handleDelete = (id: string) => {
    const { depositData } = this.state;

    const index = depositData.findIndex((item) => item.id === id);
    if (index !== -1) {
      const newData = [...depositData.slice(0, index), ...depositData.slice(index + 1)];

      const updatedTotalDeposit = newData.reduce((acc, curr) => acc + curr.amount, 0);

      this.props.onDepositUpdate(updatedTotalDeposit, newData);

      this.setState({
        depositData: newData,
        totalDeposit: updatedTotalDeposit,
      });
    }
  };

  render() {
    const { searchInput, totalDeposit, depositData, submitting } = this.state;

    return (
      <React.Fragment>
        <Form.Item>
          <Row>
            <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 10 }}>
              <i className={`text-small-grey-nopadding`}>
                Deposit ID <span style={{ color: "red" }}>*</span>{" "}
              </i>
            </Col>
          </Row>
          <Row>
            <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 10 }}>
              <Space.Compact style={{ width: "100%" }}>
                <Input placeholder="ID Deposit" value={searchInput} onChange={(e) => this.setState({ searchInput: e.target.value })} />
                <Button icon={<SearchOutlined />} onClick={this.handleSearch} type="primary" loading={submitting} />
              </Space.Compact>
            </Col>
            <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 10, textAlign: "right", verticalAlign: "bottom" }}>
              <br />
              <strong>Total Deposit : Rp. {totalDeposit.toLocaleString()}</strong>
            </Col>
          </Row>
        </Form.Item>

        <Table rowKey={"id"} size={"small"} loading={submitting} columns={this.tableColumn} dataSource={depositData} pagination={false} />
      </React.Fragment>
    );
  }
}

export default DepositComponent;
